export default "__VITE_ASSET__CQTZXF_t__"